module.exports = __webpack_public_path__ + "img/jwgl-kbcx-bjkb.416727e3.png";